import { useEffect, useState } from 'react';
import { getOwnOfficerStatus } from '../services/authService';

export function useOfficerApproval(enabled) {
  const [approved, setApproved] = useState(false);
  const [loading, setLoading] = useState(enabled);
  const [prevEnabled, setPrevEnabled] = useState(enabled);

  // Reset loading synchronously (during render) when `enabled` flips, so the
  // guard never sees a stale `approved: false, loading: false` pair from
  // before the fetch has a chance to run on reload.
  if (enabled !== prevEnabled) {
    setPrevEnabled(enabled);
    setLoading(enabled);
    if (!enabled) {
      setApproved(false);
    }
  }

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let mounted = true;

    getOwnOfficerStatus()
      .then((value) => {
        if (mounted) setApproved(value);
      })
      .catch(() => {
        if (mounted) setApproved(false);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [enabled]);

  return { approved, loading };
}
